import { render, staticRenderFns } from "./AddMiniprogram.vue?vue&type=template&id=77c46ac8&scoped=true&"
import script from "./AddMiniprogram.vue?vue&type=script&lang=js&"
export * from "./AddMiniprogram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c46ac8",
  null
  
)

export default component.exports